import getInstance from './instance';

export const loginUser = payload => getInstance()
  .post('api/auth/login', payload)
// export const loginUser = payload => new Promise((resolve, reject) => {
//   resolve('token')
// })
